import { render } from "./USBankProtectCyberscamScenarios.vue?vue&type=template&id=018ecc2a&scoped=true"
import script from "./USBankProtectCyberscamScenarios.vue?vue&type=script&lang=js"
export * from "./USBankProtectCyberscamScenarios.vue?vue&type=script&lang=js"

import "./USBankProtectCyberscamScenarios.vue?vue&type=style&index=0&id=018ecc2a&scoped=true&lang=sass"

import exportComponent from "../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-018ecc2a"]])

export default __exports__